import { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import { useDispatch } from "react-redux";
import { editBreakTypeList, getBreakTypeList, getLocationFilterList } from "./endpoints/action";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useSessionStorage from "../../hooks/useSessionStorage";
import '../AddLocation/addLocation.css'

export const BreakType = ({ locationDetails, rowData, setRowData, errors, validateForm, setErrors, previousBreakState, setPreviousBreakState, setBreakTypeDisableBtn, setUpdateBreakType, editId, setEditId }) => {
  // Use Location
  const location = useLocation();
  // Use Config
  const config = useConfiguration();
  // Use Dispatch
  const dispatch = useDispatch();


  const storage = useSessionStorage();
  const login = storage.getItem('login');

  // Duration in Minitues
  let series = [];
  for (let i = 0; i < 18; i++) {
    // series.push(5 + i * 5);
    series.push(
      <option key={i} value={5 + i * 5} className="text-center">
        {5 + i * 5}
      </option>
    );
  }

  const handleSelectChange = (event, breakTypeId) => {
    const { value } = event.target;
    setRowData((prevData) =>
      prevData.map((row) =>
        row.breakTypeId === breakTypeId
          ? { ...row, durationInMinutes: value }
          : row
      )
    );
    
  };

  const handleRadioChange = (event, breakTypeId) => {
    const { value } = event.target;
    const isPaidBreak = value === "yes"; // Convert 'yes' or 'no' to boolean
    setRowData((prevData) =>
      prevData.map((row) =>
        row.breakTypeId === breakTypeId ? { ...row, isPaidBreak } : row
      )
    );
  };


  const val =  previousBreakState.map(item => {
    const matchingBreakSetting = locationDetails?.locationWorkBreakSetting
    .find(setting => setting.breakTypeId === item.breakTypeId);
    return {
      breakTypeId: item.breakTypeId,
      breakTypes: item.breakTypes,
      durationInMinutes: locationDetails ? (matchingBreakSetting ? matchingBreakSetting.durationInMinutes : "") : "",
      isPaidBreak: locationDetails ? (matchingBreakSetting ? matchingBreakSetting.isPaidBreak : '') : '',
      locationsWorkBreakSettingId: locationDetails ? (matchingBreakSetting ? matchingBreakSetting.locationsWorkBreakSettingId : '') : '',
      locationId: locationDetails ? locationDetails?.locationId : '',
    };
  })

  const handleEdit = (data) => {
    setEditId(data?.breakTypeId);
    setBreakTypeDisableBtn(true);
    const filterBreakID = val?.find(item => item.breakTypeId === data?.breakTypeId)
    if (filterBreakID?.durationInMinutes === data?.durationInMinutes) {
      setRowData(val)
    }
  };

  const handleCancel = (data) => {
    setEditId(data?.breakTypeId !== editId);
    setBreakTypeDisableBtn(false);
    const filterBreakID = val?.find(item => item.breakTypeId !== data?.breakTypeId)
    if (filterBreakID?.durationInMinutes !== data?.durationInMinutes) {
      setRowData(val)
    }
  };


  // Break Type update list
  const updateBreakTypeList = (data) => {
    const params = {
      "locationsWorkBreakSettingId": data?.locationsWorkBreakSettingId ? data?.locationsWorkBreakSettingId : 0,
      "locationId": data?.locationId,
      "breakTypeId": data?.breakTypeId,
      "durationInMinutes": parseInt(data?.durationInMinutes),
      "isPaidBreak": data?.isPaidBreak,
      "isDeleted": 0
    }

  
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } 
    else {
      if (config.baseUrl) {
        const url = `${config.baseUrl}/Locations/update-location-work-break-setting`
        dispatch(editBreakTypeList(url, params)).then(() => {
          dispatch(getLocationFilterList(config.baseUrl, login.employerId, login.employerUniqueId, locationDetails.locationId)).then((response) => {
            setUpdateBreakType(response)
            setEditId('');
            setBreakTypeDisableBtn(false)
          })
        })
      }
    }
  }

  return (
    <>
      <div className="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      style={{
                        textTransform: "capitalize",
                        textAlign: "center",
                      }}
                    >
                      No
                    </th>
                    <th
                      style={{
                        textTransform: "capitalize",
                        textAlign: "center",
                      }}
                    >
                      Break Type
                    </th>
                    <th
                      style={{
                        textTransform: "capitalize",
                        textAlign: "center",
                      }}
                    >
                      Duration (In Minutes)
                    </th>
                    <th
                      style={{
                        textTransform: "capitalize",
                        textAlign: "center",
                      }}
                    >
                      Paid Time
                    </th>
                    {locationDetails ? (
                      <th
                        style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}
                      >
                        Edit
                      </th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {rowData?.map((item, index) => {
                    return item?.breakTypeId === editId ? (
                      <tr>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{item?.breakTypes}</td>
                        <td className="d-flex justify-content-center">
                          <span className="d-flex flex-column align-items-center">
                            <Form.Control
                              as="select"
                              style={{ width: "100px" }}
                              isInvalid={
                                // !!errors.breakType
                                item?.durationInMinutes === "" ||
                                item?.durationInMinutes === 0 || item?.durationInMinutes === '0'
                                  ? errors.breakType
                                  : false
                              }
                              onChange={(e) =>
                                handleSelectChange(e, item?.breakTypeId)
                              }
                            >
                              <option value="0">--Select--</option>
                              {series}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {item?.durationInMinutes === "" ||
                              item?.durationInMinutes === 0 || item?.durationInMinutes === '0'
                                ? errors.breakType
                                : ""}
                            </Form.Control.Feedback>
                          </span>
                        </td>
                        <td className="text-center">
                        <div className="text-center mt-2 d-flex gap-3 justify-content-center">
                            <label className="radio-inline">
                              <input
                                type="radio"
                                name={`paidBreak_${item?.breakTypeId}`}
                                value="yes"
                                checked={item?.isPaidBreak === true}
                                onChange={(e) =>
                                  handleRadioChange(e, item?.breakTypeId)
                                }
                              />
                              Yes
                            </label>
                            <label className="radio-inline">
                              <input
                                type="radio"
                                name={`paidBreak_${item?.breakTypeId}`}
                                value="no"
                                checked={item?.isPaidBreak === false}
                                onChange={(e) =>
                                  handleRadioChange(e, item?.breakTypeId)
                                }
                              />
                              No
                            </label>
                          </div>
                          <span className="text-danger" style={{fontSize:'12.5px'}}>
                            {item?.isPaidBreak === "" ? errors.paidBreak : ''}
                          </span>
                          {/* <div className="text-center mt-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={(e) =>
                                handleCheckboxChange(e, item?.breakTypeId)
                              }
                            />
                          </div> */}
                        </td>
                        {locationDetails ? (
                          <td className="text-center d-flex gap-2 justify-content-center">
                            <button className="btn btn-primary" onClick={() => updateBreakTypeList(item)}>Update</button>
                            <button className="btn btn-outline-primary" onClick={() => handleCancel(item)}>Cancel</button>
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      <tr>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{item?.breakTypes}</td>
                        <td className="d-flex justify-content-center">
                          <span className="d-flex flex-column align-items-center">
                            <Form.Control
                              as="select"
                              style={{ width: "100px",
                            }}
                              disabled={locationDetails ? true : false}
                              value={item?.durationInMinutes}
                              isInvalid={
                                // !!errors.breakType
                                item?.durationInMinutes === "" ||
                                item?.durationInMinutes === "0" 
                                  ? errors.breakType
                                  : false
                              }
                              onChange={(e) =>
                                handleSelectChange(e, item?.breakTypeId)
                              }
                            >
                              <option value="0">--Select--</option>
                             {series}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {item?.durationInMinutes === "" ||
                              item?.durationInMinutes === "0"
                                ? errors.breakType
                                : ""}
                            </Form.Control.Feedback>
                          </span>
                        </td>
                        <td className="text-center">
                          <div className="text-center mt-2 d-flex gap-3 justify-content-center">
                            <label className="radio-inline">
                              <input
                                type="radio"
                                name={`paidBreak_${item?.breakTypeId}`}
                                disabled={locationDetails ? true : false}
                                value="yes"
                                checked={item?.isPaidBreak === true}
                                onChange={(e) =>
                                  handleRadioChange(e, item?.breakTypeId)
                                }
                              />
                              Yes
                            </label>
                            <label className="radio-inline">
                              <input
                                type="radio"
                                name={`paidBreak_${item?.breakTypeId}`}
                                disabled={locationDetails ? true : false}
                                value="no"
                                checked={item?.isPaidBreak === false}
                                onChange={(e) =>
                                  handleRadioChange(e, item?.breakTypeId)
                                }
                              />
                              No
                            </label>
                          </div>
                          <span className="text-danger" style={{fontSize:'12.5px'}}>
                            {item?.isPaidBreak === "" ? errors.paidBreak : ''}
                          </span>
                          {/* <div className="text-center mt-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={item?.isPaidBreak}
                              onChange={(e) =>
                                handleCheckboxChange(e, item?.breakTypeId)
                              }
                            />
                          </div> */}
                        </td>
                        {locationDetails ? (
                          <td className="text-center">
                            <button
                              id="bEdit"
                              type="button"
                              class="btn btn-sm btn-height"
                              title="Edit"
                              style={{ "font-size": "1.1rem" }}
                              onClick={() => handleEdit(item)}
                            >
                              <FiEdit />
                            </button>
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
